import { atom } from "recoil";

export const superUserStatus = atom({
  key: "superUser",
  default: false,
});
